import {EventTypeResponse} from "../../data/events/EventTypeResponse";
import {
    Alert,
    Button, Checkbox,
    FormControlLabel,
    FormGroup,
    Input,
    MenuItem,
    Paper,
    Select,
    Stack,
    Typography
} from "@mui/material";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import React, {useState} from "react";
import dayjs from "dayjs";
import useApiCall, {makeApiCall} from "../../hooks/CancellableApiCall";
import {LoadingContent} from "../../components/LoadingContent";
import {useNavigate, useParams} from "react-router-dom";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";

interface EventCreationPageContentProps {
    eventTypes: EventTypeResponse[],
    preloadedEventType?: string
}

const EventCreationPageContent = (props: EventCreationPageContentProps) => {
    const [date, setDate] = useState(dayjs())
    const [eventType, setEventType] = useState(props.preloadedEventType ?? "")
    const [eventDesc, setEventDesc] = useState("")
    const [eventLength, setEventLength] = useState(120)
    const [eventPrivate, setEventPrivate] = useState(true)
    const navigate = useNavigate()

    return <Stack spacing={1}>
        {props.eventTypes.find(e => {return e.identifier === eventType})?.serverTraining === true && props.eventTypes.some(e => {return e.identifier === eventType}) ?
            <Alert severity="error" variant={"filled"}>Events linked to in-game items cannot be made at the moment, this will be resolved in the next PLPD Online release, a MVP was released in the interest of time - Development Services</Alert> : <></>
        }
        <Typography sx={{pt:2}} variant="h6" gutterBottom>Event Creation</Typography>
        <Paper variant="outlined" style={{
            marginTop: "16px",
            padding: "16px"
        }}>
            <DialogContent>
                <DialogContentText>Date and Time</DialogContentText>
                <DateTimePicker
                    defaultValue={date}
                    disablePast
                    format="DD/MM/YYYY HH:mm"
                    onChange={(event) => {setDate(event!!)}}
                />
            </DialogContent>
            <DialogContent>
                <DialogContentText>Event Type</DialogContentText>
                <Select
                    id={`select-event`}
                    value={eventType}
                    sx={{width: 500}}
                    onChange={(event) => {
                        setEventType(event.target.value as string)
                    }}
                    variant="standard"
                    label="Event Type Select"
                >
                    {
                        props.eventTypes && props.eventTypes.map((event, idx) => {
                            return <MenuItem key={idx} value={event.identifier}>{event.displayName}</MenuItem>
                        })
                    }
                </Select>
            </DialogContent>
            <DialogContent>
                <DialogContentText>Event Length (Minutes)</DialogContentText>
                <Input
                       value={eventLength}
                       type={"number"}
                       onChange={(event) => {
                           let number = Number(event.target.value)
                           if (number < 1) {
                               setEventLength(1)
                           } else if (number > 240) {
                               setEventLength(240)
                           } else {
                               setEventLength(number)
                           }
                       }}/>
            </DialogContent>
            <DialogContent>
                <DialogContentText>Event Description</DialogContentText>
                <Input multiline rows={4} placeholder="Enter here..."
                       value={eventDesc}
                       sx={{minWidth: "100%"}}
                       onChange={(event) => setEventDesc(event.target.value)}/>
            </DialogContent>
            <DialogContent>
                <FormGroup>
                    <FormControlLabel control={<Checkbox
                        value={eventPrivate}
                        defaultChecked
                        onChange={() => setEventPrivate(!eventPrivate)}
                    />} label="Private Event" />
                </FormGroup>
            </DialogContent>
            <DialogContent>
                <Button size={"medium"} sx={{maxWidth: "200px"}} color="success" variant="contained"
                        disabled={
                            (!props.eventTypes.some(e => {return e.identifier === eventType})) ||
                            (props.eventTypes.find(e => {return e.identifier === eventType})?.serverTraining === true)
                        }
                        onClick={() => {
                            makeApiCall({
                                url: `/api/event`,
                                method: "POST",
                                body: {
                                    typeIdentifier: eventType,
                                    private: eventPrivate,
                                    date: date,
                                    length: eventLength,
                                    description: eventDesc
                                },
                                onLoadedCallback: (data: {eventId: number}) => {
                                    navigate(`/event/view/${data.eventId}`)
                                },
                                onError: () => {}
                            })
                        }}>
                    Create Event<CalendarMonthIcon/></Button>
            </DialogContent>
        </Paper>
    </Stack>
}

export const EventCreationPage = () => {
    const params = useParams()
    const loadEventTypes = useApiCall<EventTypeResponse[]>({
        initialUrl: `/api/event/types/info`
    })

    return <LoadingContent isLoading={
        loadEventTypes.isLoading || !loadEventTypes.data
    }>
        <EventCreationPageContent eventTypes={loadEventTypes.data!!} preloadedEventType={params.event}/>
    </LoadingContent>
}